import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css';
import mobileSlides from './directives/mobileSlides';

createApp(App).use(store).use(router).directive('mobile-slides', mobileSlides).mount('#app')
